import { useWebSocketConnection } from '@nest/internal-frontend';
import { environment } from '../environment';

export const useWebSocket = () => {
	return useWebSocketConnection({ url: environment.websocketUrl, applicationName: environment.applicationName });
};
